import TeamsLogo from '@/assets/images/teams.svg';

const TeamsIcon = ({ size = 25 }) => (
    <img
        src={TeamsLogo}
        alt="Microsoft Teams Logo"
        style={{ height: size, width: size }}
    />
);

export default TeamsIcon;
